export default function isFunction(val) {
  return typeof val === 'function';
}